export const env = {
  synthia: process.env.REACT_APP_SYNTHIA_ADDRESS || "0xabf0b84f870ff3b45988e49fd62b881d7c46c6e6",
};

const missingEnvVars = Object.values(env).some((val) => !val);

if (missingEnvVars) {
  console.error("MISSING ENV VARS");
}

console.log(env);
